import { toast } from "sonner";

export const confirmToast = (message, onConfirm, confirmText = "Confirmar", isDanger = true) => {
  toast.custom(
    (t) => (
      <div className="flex flex-col gap-3 min-w-[280px] p-4 bg-white border border-border shadow-lg rounded-md">
        <span className="text-[13px] font-medium text-foreground">
          {message}
        </span>
        <div className="flex justify-end gap-2 mt-1">
          <button
            onClick={() => toast.dismiss(t)}
            className="px-3 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-sm hover:bg-gray-200 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={() => {
              toast.dismiss(t);
              onConfirm();
            }}
            className={`px-3 py-1.5 text-xs font-medium text-white rounded-sm transition-colors ${
              isDanger 
                ? "bg-red-600 hover:bg-red-700" 
                : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    ),
    {
      duration: 100000,
      position: "top-center",
    }
  );
};